import About from "./components/About";
import Products from "./components/Products";
import Home from "./components/Home";
import ProdView from "./components/ProdView";
import Distributors from "./components/Distributors";
import NotFound from './components/NotFound';

const AppRoutes = [
    {
        index: true,
        path: '/',
        element: <Home />
    },
    {
        path: '/about',
        element: <About />
    },
    {
        path: '/products',
        element: <Products />
    },
    {
        path: '/ProdView/:productName',
        element: <ProdView />
    },
    {
        path: '/distributors',
        element: <Distributors />
    },
    {
        path: '*',
        element: <NotFound />,
    },
];

export default AppRoutes;
